import type { AppRouter } from "@arbeidsark/api"
import { createTRPCReact } from "@trpc/react-query"

export const trpc = createTRPCReact<AppRouter>()
